<h2 mat-dialog-title>Modifica board</h2>
<ng-container *ngIf="editableColumns?.length">

  <div mat-dialog-content>

    <div class="columnDescription">
      <span>mostra</span>
      <span>etichetta</span>
      <span>sposta</span>
    </div>

    <div cdkDropList (cdkDropListSorted)="saveBtnDisabled = false" cdkDropListOrientation="vertical"
      [cdkDropListData]="editableColumns" class="tableColumnList" (cdkDropListDropped)="drop($event)"
      [cdkDropListSortPredicate]="sortDamPrefixedItem">

      <div class="tableColumnListItem" *ngFor="let column of editableColumns" cdkDrag cdkDragLockAxis="y"
        [cdkDragDisabled]="column.isFixed" [ngClass]="column.isFixed ? 'undraggable': ''"
        cdkDragBoundary=".tableColumnList">

        <mat-checkbox (change)="$event ? columnsSelection?.toggle(column) : null" (click)="$event.stopPropagation()"
          [checked]="columnsSelection?.isSelected(column)"
          [disabled]="(columnsSelection?.isSelected(column) && disableCheckBoxes) || !column.isSelectable">
        </mat-checkbox>

        <span class="boardNameText">{{ column.name | translateColumn:boardName}}</span>

        <mat-icon class="dragHandle" [ngClass]="column.isFixed ? 'disabledHandle': ''" cdkDragHandle>drag_handle
        </mat-icon>
      </div>
    </div>

  </div>
  <div mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="onResetClick()">Reset</button>
    <button mat-stroked-button color="basic" (click)="onCancelClick()">Annulla</button>
    <button mat-flat-button color="warn" (click)="onSaveClick()" [disabled]="saveBtnDisabled">Salva</button>
  </div>

</ng-container>
